/**
 * Convierte una fecha en formato string "YYYY-MM-DD" a un formato legible.
 * @param dateStr La fecha en formato string.
 * @returns La fecha formateada (ej: "18 de agosto de 2025").
 */
export function formatDate(dateStr: string): string {
  const date = new Date(dateStr);
  date.setUTCHours(12);
  const day = date.getUTCDate();
  const month = date.toLocaleDateString('es-CO', { month: 'long', timeZone: 'UTC' });
  const capitalizedMonth = month.charAt(0).toUpperCase() + month.slice(1);
  const year = date.getUTCFullYear();
  return `${day}/${capitalizedMonth}/${year}`;
}

/**
 * Formatea un número como moneda colombiana (COP).
 * @param amount El monto numérico.
 * @returns El monto formateado como string (ej: "$57.817").
 */
export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0,
  }).format(amount);
}

/**
 * Determina el estado de una factura basado en su fecha de vencimiento y si es pagable.
 * @param dueDateStr La fecha de vencimiento.
 * @param isPayable Verdadero si la factura no tiene deudas más antiguas en la misma póliza.
 * @returns El estado de la factura.
 */
export function getInvoiceStatus(
  dueDateStr: string,
  isPayable: boolean
): 'En riesgo de cancelación' | 'Disponible para pago' {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const dueDate = new Date(dueDateStr);
  dueDate.setUTCHours(12);
  dueDate.setHours(0, 0, 0, 0);

  const diffDays = Math.ceil(
    (dueDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24)
  );

  if (diffDays < 0) {
    return 'En riesgo de cancelación';
  }
  return 'Disponible para pago';
}
